export const isOutsideOntario = (isEventSet: Boolean, eventData: any): Boolean => (
  (isEventSet && (eventData.events.totalCount > 0) && (eventData.events.nodes[0].region !== 'Ontario')) ||
  (!isEventSet && (eventData.region !== 'Ontario'))
)
